<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/rServiceDetail' }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>客户物流管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="customer_wrap">
        <div class="select_add flex-rowl">
          <p class="btn flex-rowl" @click="handleGo(0)">
            <i class="iconfont icon-xinzeng"></i> 新增物流信息
          </p>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="(item, index) in dataList" :key="index">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleGo(item.id)">
                  <div class="block">
                    <p>
                      姓名：<span>{{ item.truename }}</span>
                    </p>
                    <p>
                      手机号：<span>{{ item.mobile }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      物流类型：<span>{{
                        item.runtype == 1
                          ? "私人"
                          : item.runtype == 2
                          ? "办公"
                          : ""
                      }}</span>
                    </p>
                    <p>
                      所在地区：<span>{{ item.provincestr }}</span>
                      <span>{{ item.citystr }}</span>
                      <span>{{ item.areastr }}</span>
                      <span>{{ item.addr }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      是否默认：<span>{{ item.isdefault }}</span>
                    </p>
                    <p>
                      是否启用：<span>{{
                        item.isuse == 1
                          ? "启用"
                          : item.isuse == 0
                          ? "停用"
                          : ""
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getCustomAddressList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "addressList",
  data() {
    return {
      id: "",
      customerGuid: "",
      loading: false,
      listTotal: 0,
      dataList: [],
      customerDetail: "", // 客户详情
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, customerGuid } = JSON.parse(res.jsondata);
        this.id = id;
        this.customerGuid = customerGuid;
        this.getCustomAddressList();
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomAddressList() {
      this.loading = true;
      getCustomAddressList({ guid: this.customerGuid }).then((res) => {
        this.dataList = res.list;
        this.loading = false;
      });
    },

    handleReturn() {
      this.$router.back();
    },
    handleGo(id) {
      // this.$router.push(
      //   `/resourceIndex/addressDetail/${this.id}/${this.customerGuid}/${id}`
      // );
      this.encryptstringadd("addressDetail", {
        id: this.id,
        customerGuid: this.customerGuid,
        addressId: id,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .customer_wrap {
    font-size: 16px;
    color: #404d6c;
    padding: 15px 0 20px;
    .btn {
      border: 1px solid #6b5e84;
      padding: 4px 15px;
      border-radius: 45px;
      margin-right: 20px;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
  .main_container {
    .list_wrap {
      height: 61vh;
      .intro_box {
        cursor: pointer;
      }
      .red {
        color: #ff0036;
      }
    }
  }
  .form_footer {
    .btn {
      margin-right: 30px;
    }
  }
}
</style>